import Chargement from "../components/chargement";

const Formation = () => {
    return (
        <div><Chargement /></div>
    );
}

export default Formation;